<template>
  <b-form-group
    label="Mülk Durumu"
    label-for="status"
  >
    <b-form-checkbox
      id="status"
      v-model="dataItem.status"
      value="1"
      switch
    >
      {{ dataItem.status === '1' ? 'Aktif' : 'Pasif' }}
    </b-form-checkbox>
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'StatusSelect',
  components: {
    BFormGroup, BFormCheckbox,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
}
</script>
